import { createFeature } from '@ngrx/store';

import { mentionableUsersReducer } from './mentionable-users.reducer';

export const mentionableUsersFeatureKey = 'mentionableUsers';

export const mentionableUsersFeature = createFeature({
  name: mentionableUsersFeatureKey,
  reducer: mentionableUsersReducer,
});
